import { render, staticRenderFns } from "./ViqCompareMarkets.vue?vue&type=template&id=1aa7d554&scoped=true"
import script from "./ViqCompareMarkets.vue?vue&type=script&lang=js"
export * from "./ViqCompareMarkets.vue?vue&type=script&lang=js"
import style0 from "./ViqCompareMarkets.vue?vue&type=style&index=0&id=1aa7d554&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa7d554",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1aa7d554')) {
      api.createRecord('1aa7d554', component.options)
    } else {
      api.reload('1aa7d554', component.options)
    }
    module.hot.accept("./ViqCompareMarkets.vue?vue&type=template&id=1aa7d554&scoped=true", function () {
      api.rerender('1aa7d554', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/viq/ViqCompareMarkets.vue"
export default component.exports